import type { ComponentPropsWithoutRef } from 'react';
import { cn } from 'src/utils/cn';

export const HeaderSecondaryBackground = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      {...props}
      className={cn(`border-b border-[#e7e7e7] bg-white`, className)}
    />
  );
};

export const HeaderSecondaryCenter = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div {...props} className={cn(`min-h-[4.3rem] py-[0.4rem]`, className)} />
  );
};
